import { render, staticRenderFns } from "./vue-simple-suggest.vue?vue&type=template&id=7ffe1e65&"
import script from "./vue-simple-suggest.vue?vue&type=script&lang=js&"
export * from "./vue-simple-suggest.vue?vue&type=script&lang=js&"
import style0 from "./vue-simple-suggest.vue?vue&type=style&index=0&id=7ffe1e65&prod&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports